import { CheckIcon, LoaderIcon, XIcon } from 'lucide-react'

import { DocumentError } from '@/gen/artifacts/v1/model_pb'

import { DocumentStatus } from '@/const/artifact-status.types'

import { assertUnreachable } from '@/utils/type-utils'

type DocumentStatusIconProps = {
  status: DocumentStatus
  error?: DocumentError | null
}

export const DocumentStatusIcon = ({ status, error }: DocumentStatusIconProps) => {
  if (error) {
    return <XIcon size={14} strokeWidth={1.5} />
  }

  switch (status) {
    case DocumentStatus.COMPLETE:
      return <CheckIcon size={14} strokeWidth={1.5} />
    case DocumentStatus.CLASSIFYING:
      return <LoaderIcon size={14} strokeWidth={1.5} className='animate-spin duration-2500' />
    case DocumentStatus.PENDING:
    case DocumentStatus.UNSPECIFIED:
      return null
    default:
      return assertUnreachable(status)
  }
}
